import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex justify-content-between align-items-center flex-wrap gap-2" }
const _hoisted_3 = { class: "chart-title mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "metrics-skeleton"
}
const _hoisted_7 = {
  key: 1,
  class: "chart-skeleton"
}
const _hoisted_8 = { class: "mt-2 text-danger mb-0" }

import { computed } from 'vue';


export default {
  __name: 'ChartCard',
  props: {
  title: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: [Object, Error, String],
    default: null,
  },
  isEmpty: {
    type: Boolean,
    default: false,
  },
  /**
   * 'chart' — bar-chart skeleton bars
   * 'metrics' — three metric-card placeholders
   */
  skeletonVariant: {
    type: String,
    default: 'chart',
  },
  emptyClass: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;

const errorMessage = computed(() => {
  if (!props.error) return '';
  if (typeof props.error === 'string') return props.error;
  return props.error.message || 'Fehler beim Laden der Daten';
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(__props.title), 1 /* TEXT */),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (__props.loading && __props.skeletonVariant === 'metrics')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "skeleton skeleton-metric" }, null, -1 /* CACHED */),
            _createElementVNode("div", { class: "skeleton skeleton-metric" }, null, -1 /* CACHED */),
            _createElementVNode("div", { class: "skeleton skeleton-metric" }, null, -1 /* CACHED */)
          ]))]))
        : (__props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "skeleton skeleton-axis" }, null, -1 /* CACHED */),
              _createElementVNode("div", { class: "skeleton skeleton-bar" }, null, -1 /* CACHED */),
              _createElementVNode("div", { class: "skeleton skeleton-bar w-75" }, null, -1 /* CACHED */),
              _createElementVNode("div", { class: "skeleton skeleton-bar w-50" }, null, -1 /* CACHED */)
            ]))]))
          : (__props.error)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["chart-empty", __props.emptyClass]),
                role: "alert"
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("i", {
                  class: "fas fa-exclamation-triangle text-danger",
                  style: {"font-size":"2.2rem"}
                }, null, -1 /* CACHED */)),
                _createElementVNode("p", _hoisted_8, _toDisplayString(errorMessage.value), 1 /* TEXT */)
              ], 2 /* CLASS */))
            : (__props.isEmpty)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: _normalizeClass(["chart-empty", __props.emptyClass])
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", {
                    class: "fas fa-chart-bar text-muted",
                    style: {"font-size":"2.2rem"}
                  }, null, -1 /* CACHED */),
                  _createElementVNode("p", { class: "mt-2 text-muted" }, " Keine Daten verfügbar ", -1 /* CACHED */)
                ]))], 2 /* CLASS */))
              : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 4)
    ])
  ]))
}
}

}